import SyncableModel from './SyncableModel';

export default class BroodStockProduct extends SyncableModel {
  static name = 'BroodStockProduct'

  _fillable = [
    "id",
    "brood_stock_supplier_id",
    "species_id",
    "name",
    "aliases",
    "description",
    "verified",
    "created_at",
    "updated_at",
    "supplier_product_name",
    "brood_stock_supplier_name"
  ]

  incrementing = false

  static syncOnly = true

  static hasSyncedAt = false

  _casts = {
    id: "integer",
    brood_stock_supplier_id: "integer",
    species_id: "integer",
    verified: "boolean"
  }

  static endpoint = '/brood_stock_products'

  static online = true
}
